import { FC, useEffect } from 'react'
import { getTitle, getDescription, setTitle, setDescription } from 'helpers/DOMHelpers'

type PageMetaProps = {
  title?: string
  description?: string
}

export const PageMeta: FC<PageMetaProps> = (props) => {
  const { title, description } = props

  useEffect(() => {
    const initialProps = {
      title: getTitle(),
      description: getDescription(),
    }

    if (title) {
      setTitle(title)
    }

    if (description) {
      setDescription(description)
    }

    return () => {
      setTitle(initialProps.title)
      setDescription(initialProps.description)
    }
  }, [title, description])

  return null
}
